import { render, staticRenderFns } from "./styled-dialog-header.vue?vue&type=template&id=60ec2c2d&scoped=true&"
import script from "./styled-dialog-header.vue?vue&type=script&lang=js&"
export * from "./styled-dialog-header.vue?vue&type=script&lang=js&"
import style0 from "./styled-dialog-header.vue?vue&type=style&index=0&id=60ec2c2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec2c2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSpacer,VToolbar,VToolbarTitle})
